import {ColorCodingOption} from "./@type";

export enum MyWorkType {

    TASK            = 1,
    EVENT           = 2,
    MOM             = 3,
    REPORT          = 4,
    REMINDER        = 6,
    RATE_EXPERIENCE = 8,
    TASK_ASSIGNED   = 9,        // experimental
    TODO            = 10
}

export enum MyWorkViewDisplayItem {

    MILESTONE               = "milestone",
    PERSONAL_EVENT          = "personal-event",
    COMPANY_EVENT           = "company-event",
    ACTION_REQUIRED_TASK    = "action-required-task",
    ASSIGNED_TO_TASK        = "assigned-to-task",
    DEADLINE                = "deadline",
    MEETING                 = "meeting",
    REMINDER                = "reminder",
    REPORT                  = "report",
    MENTION                 = "mention",

}



export enum BoardCardColor {
    PROJECT   = 'project',
    STATUS    = 'status',
    NONE      = 'none'
}

export enum BoardCardColorCoding {
    LEFT    = 'left',
    TOP     = 'top',
    FILL    = 'fill',
    NONE    = 'none'
}


export const defaultColorCodingOptions: ColorCodingOption[] = [
    {
        value   : BoardCardColorCoding.LEFT,
        img     : '/app/web/skin/common/svg/board-color-coding/left.svg'
    },
    {
        value   : BoardCardColorCoding.TOP,
        img     : '/app/web/skin/common/svg/board-color-coding/top.svg'
    },
    {
        value   : BoardCardColorCoding.FILL,
        img     : '/app/web/skin/common/svg/board-color-coding/fill.svg'
    },
    {
        value   : BoardCardColorCoding.NONE,
        img     : '/app/web/skin/common/svg/board-color-coding/none.svg'
    }
]


export const defaultDisplayItemsTypes: MyWorkViewDisplayItem[] = [
    MyWorkViewDisplayItem.ACTION_REQUIRED_TASK,
    MyWorkViewDisplayItem.ASSIGNED_TO_TASK,
    MyWorkViewDisplayItem.DEADLINE,
    MyWorkViewDisplayItem.MILESTONE,
    MyWorkViewDisplayItem.PERSONAL_EVENT,
    MyWorkViewDisplayItem.MEETING,
    MyWorkViewDisplayItem.REMINDER,
    MyWorkViewDisplayItem.REPORT,
    MyWorkViewDisplayItem.MENTION
]
